module.exports = __webpack_public_path__ + "static/media/tofy-bnb.bfdf8091.png";